<template lang="pug">
.plan-prices
    .plan-prices__group(
        v-for="(room, index) in rooms"
        :key="index"
    )
        span.plan-prices__label
            | {{ room.title }}

        SvInput.plan-prices__input(
            v-model="price[room.fullkey]"
            placeholder="Полноценные"
            color="graylight"
            :withIcon="false"
        )

        SvInput.plan-prices__input(
            v-if="'studiokey' in room"
            v-model="price[room.studiokey]"
            placeholder="Студии"
            color="graylight"
            :withIcon="false"
        )
</template>

<script>
import SvInput from '@/components/uikit/SvInput.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'PlanPrices',

  data() {
    return {
      rooms: [
        {
          title: 'Цена 1-ком квартиры в руб.',
          fullkey: 'one_room',
          studiokey: 'one_room_studio',
        },
        {
          title: 'Цена 2-ком квартиры в руб.',
          fullkey: 'two_rooms',
          studiokey: 'two_rooms_studio',
        },
        {
          title: 'Цена 3-ком квартиры в руб.',
          fullkey: 'three_rooms',
          studiokey: 'three_rooms_studio',
        },
        {
          title: 'Цена 4-ком квартиры в руб.',
          fullkey: 'four_rooms',
          studiokey: 'four_rooms_studio',
        },
        {
          title: 'Цена 5-ком квартиры в руб.',
          fullkey: 'five_rooms',
          studiokey: 'five_rooms_studio',
        },
        {
          title: 'Цена 6-ком квартиры в руб.',
          fullkey: 'six_rooms',
          studiokey: 'six_rooms_studio',
        },
        {
          title: 'Свободная планировка',
          fullkey: 'free',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      current: 'residential/getCurrent',
    }),

    price: {
      get() {
        return this.current.price;
      },
      set(price) {
        this.setValue({ price });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),
  },

  components: {
    SvInput,
  },
};
</script>

<style lang="scss" scoped>
.plan-prices {
    &__group {
        display: grid;
        grid-template-columns: 215px 311px 311px;
        grid-column-gap: 22px;
        align-items: center;
        justify-items: flex-end;
        margin-bottom: 23px;
    }
}
</style>
